import { composeReducers } from 'common/util/composeReducers';
import lodash from 'lodash';
import {
    UNLOAD_DOCUMENTS,
    REMOVE_DOCUMENT_FROM_LIST
} from 'pages/files/actions/files';

export function unloadDocuments(state, action) {
    if(!action || action.type !== UNLOAD_DOCUMENTS){
        return state;
    }

    return {
        ...state,
        files: {
            ...state.files,
            documents: [],
            unfiledDocuments: [],
            documentCount: 0
        }
    };
}

export function removeDocumentFromList(state, action) {
    if(!action || action.type !== REMOVE_DOCUMENT_FROM_LIST){
        return state;
    }

    const documentToRemoveId = action.payload.documentId;
    const filteredUnfiledDocuments = lodash.filter(state.files.unfiledDocuments, 
        (document) => !(document.id === documentToRemoveId));

    return {
        ...state,
        files: {
            ...state.files,
            unfiledDocuments: filteredUnfiledDocuments
        }
    };
}

export default composeReducers(
    unloadDocuments,
    removeDocumentFromList
);